import React from 'react';
import { useLanguage } from '../utils/LanguageContext';
import { Location } from '../utils/api';

interface PinnedLocationsAccordionProps {
    locations: Location[];
    onVote: (locationId: number) => Promise<void>;
}

const PinnedLocationsAccordion: React.FC<PinnedLocationsAccordionProps> = ({ locations, onVote }) => {
    const { t } = useLanguage();

    return (
        <ul className="location-list">
            {locations
                .sort((a, b) => b.votes - a.votes)
                .map((location, index) => (
                    <li key={index}>
                        <div>
                            <h3>{location.name}</h3>
                            <p>{location.address}</p>
                            <span>{location.votes} {t('location.votes')}</span>
                        </div>
                        <button
                            onClick={() => onVote(index)}
                            className="vote-button"
                        >
                            {t('location.vote')}
                        </button>
                    </li>
                ))}
        </ul>
    );
};

export default PinnedLocationsAccordion;